// extracted by mini-css-extract-plugin
export var answer = "index-module--answer--d3gXk";
export var carrot = "index-module--carrot--LcQN9";
export var container = "index-module--container--+2c+y";
export var expanded = "index-module--expanded--FUuqL";
export var question = "index-module--question--xve-z";
export var questionAnswer = "index-module--questionAnswer--TP71Y";
export var questionsContainer = "index-module--questionsContainer--Gruvu";